<template>
	<!-- A component to display version and other debug info -->
	<div v-if="!prd" id="version-display">{{ text }}</div>
</template>

<script>
import { getDeviceMetaData } from '@/utils/helpers'

export default {
	data() {
		const { env, ver, browser, os } = getDeviceMetaData()
		return {
			prd: env === 'prd',
			text: `${env}; ${ver}; ${browser}; ${os}`
		}
	}
}
</script>

<style scoped>
#version-display {
	position: fixed;
	right: 0;
	bottom: 0;
	z-index: 2001;
	padding: 1px 2px;
	color: black;
	font-size: 0.6em;
	white-space: nowrap;
	background-color: rgba(255, 255, 255, 0.9);
}
</style>
